import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { themeColor } from 'utils/styles'
import { Card as AntdCard } from 'antd'
import { Icon, Paragraph, Button, HoverableInfoIcon } from 'components/patterns'
import DaimlerLogoSvg from 'components/Footer/DaimlerLogoSvg'

export const Title = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: ${themeColor('blackPrimary')};
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const TemplateMeta = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
  margin-bottom: 10px;
`

export const CreateDateOrPartNumber = styled(Paragraph)`
  margin-right: 3px;
  font-weight: bold;
  color: ${themeColor('blackSecondary')};
`

export const Author = styled(Paragraph)`
  margin-right: 8px;
  margin-left: 8px;
  font-size: 12px;
  color: ${themeColor('blackSecondary')};
`

export const TimeStamp = styled(Paragraph)`
  margin-right: 3px;
  font-size: 12px;
  color: ${themeColor('greyPrimary')};
`

export const StyledDaimlerLogoSvg = styled(DaimlerLogoSvg)`
  flex-shrink: 0;
  margin-left: 25px;
  vertical-align: middle;
  &&& > path {
    fill: ${themeColor('black')};
    fill-opacity: 0.3;
  }
`

export const StyledCustomTemplateIcon = styled(Icon)`
  flex-shrink: 0;
  margin-left: 25px;
  &&& {
    height: 20px;
    width: 20px;
    path {
      fill: ${themeColor('bluePrimary')};
    }
  }
`

export const ContentWrapper = styled.span`
  --line-height: 18px;
  font-size: 14px;
  line-height: var(--line-height);
  color: ${themeColor('blackSecondary')};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: var(--line-height);
  min-height: calc(var(--line-height) * 2);
`

export const CheckIcon = styled(Icon)`
  margin-top: 2px;
  margin-right: 10px;
  &&& {
    height: 12px;
    width: 20px;
  }
`

export const EmptyDiffMessage = styled(Paragraph)``

export const NoDiffContent = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 16px;
`

export const StyledAntdCard = styled(AntdCard)((props) => {
  const backgroundColor = themeColor(
    props.compatible ? 'whitePrimary' : 'offWhite'
  )(props)
  return `
    height: 180px;
    width: calc(50% - 16px);
    margin: 8px;
    background-color: ${backgroundColor};
    border: 1px solid ${themeColor('greyPrimary')};
  `
})

StyledAntdCard.propTypes = {
  compatible: PropTypes.bool,
}

export const IncompatibleHint = styled.span`
  font-size: 12px;
  float: right;
  color: ${themeColor('greyPrimary')};
  display: inline-flex;
  align-items: center;
`

export const StyledHoverableInfoIcon = styled(HoverableInfoIcon)`
  margin-left: 6px;
  display: flex;
  align-items: center;
`

export const StyledSelectTemplateButton = styled(Button)`
  float: right;
  && {
    font-size: 12px;
    margin: 0;
    padding: 5px;
    height: auto;
  }
`
